import I18n from "../translations/i18n";

let account_currency = document.querySelector(".logged-in-dashboard-container")
  ? document
      .querySelector(".logged-in-dashboard-container")
      .getAttribute("data-currency")
  : "1";

export const siteUrls = {
  homepage: "/",
  join: {
    name: I18n.t("views.navigation.join"),
    href: "/users/sign_up?pid=theguestbook",
  },
  login: {
    name: I18n.t("views.navigation.login"),
    href: "/users/sign_in?pid=theguestbook",
  },
  logout: {
    name: I18n.t("views.navigation.logout"),
    href: "/users/sign_out?pid=theguestbook",
    method: "delete",
    rel: "nofollow",
  },
  twitter: "https://twitter.com/theguestbk",
  x: "https://x.com/theguestbk",
  facebook: "https://www.facebook.com/theguestbk",
  instagram: "https://www.instagram.com/theguestbk/",
  navigation: {
    homepage: {
      name: I18n.t("views.navigation.home_page"),
      href: "/",
      trackingName: "web_view_homepage",
    },
    howItWorks: {
      name: I18n.t("views.navigation.how_it_works"),
      href: "/how-it-works",
      trackingName: "web_view_how_it_works",
    },
    exploreHotels: {
      name: I18n.t("views.navigation.explore_hotels"),
      href: `https://theguestbook.com/destinations/guestbook?c_id=${account_currency}`,
      trackingName: "web_view_explore_hotels",
    },
    extension: {
      name: I18n.t("views.dmo_partners.pages.site_urls.extension"),
      href: "/extension",
      trackingName: "web_view_extension",
    },
    shrtlst: {
      name: "Shrtlst.",
      href: "https://shrtlst.com/",
      trackingName: "web_view_shrtlst",
    },
    faq: {
      name: I18n.t("views.navigation.faq"),
      href: "https://theguestbook.com/faq",
      trackingName: "web_view_faq",
    },
    business: {
      name: I18n.t("views.navigation.for_hotels"),
      href: "https://hoteliers.theguestbook.com/",
      trackingName: "web_view_for_hotels",
    },
    redeem: {
      name: I18n.t("views.navigation.redeem"),
      href: "/dashboard/home",
      trackingName: "web_view_redeem",
    },
    myAccount: {
      name: I18n.t("views.navigation.my_account"),
      href: "/dashboard/home",
      trackingName: "web_view_my_account",
    },
    cashBack: {
      name: I18n.t("views.navigation.cash_back"),
      href: "/dashboard/cash_back",
      trackingName: "web_view_cash_back",
    },
    cashForACause: {
      name: I18n.t("views.navigation.cash_for_a_cause"),
      href: "/dashboard/cash_for_a_cause",
      trackingName: "web_view_cash_for_a_cause",
    },
    cashForward: {
      name: I18n.t("views.navigation.cash_forward"),
      href: "/dashboard/cash_forward_terms",
      trackingName: "web_view_cash_forward",
    },
    instay: {
      name: I18n.t("views.navigation.instay"),
      href: "/dashboard/in_stay_hotels",
      trackingName: "web_view_instay",
    },
    missingStays: {
      name: I18n.t("views.navigation.missing_stays"),
      href: "/dashboard/home?view=missing_rewards#tour-pending",
      trackingName: "web_view_missing_stays",
    },
    profile: {
      name: I18n.t("views.navigation.profile"),
      href: "/account",
      trackingName: "web_view_profile",
    },
    language: { name: I18n.t("views.navigation.language") },
    referralProgram: {
      name: I18n.t("views.navigation.referral_program"),
      href: "/dashboard/referral_program",
      trackingName: "web_view_referral_program",
    },
    membersOnlyDeals: {
      name: I18n.t("views.navigation.member_deals"),
      href: "/membersonlydeals",
      trackingName: "web_view_member_deals",
    },
  },
  footer: {
    howItWorks: {
      name: I18n.t("views.navigation.how_it_works"),
      href: "/how-it-works",
      trackingName: "web_view_how_it_works",
    },
    exploreHotels: {
      name: I18n.t("views.navigation.explore_hotels"),
      href: `https://theguestbook.com/destinations/guestbook?c_id=${account_currency}`,
      trackingName: "web_view_explore_hotels",
    },
    faq: {
      name: I18n.t("views.navigation.faq"),
      href: "https://theguestbook.com/faq",
      trackingName: "web_view_faq",
    },
    newsroom: {
      name: I18n.t("views.navigation.newsroom"),
      href: "https://hoteliers.theguestbook.com/newsroom/",
      trackingName: "web_view_newsroom",
    },
    extension: {
      name: I18n.t("views.dmo_partners.pages.site_urls.extension"),
      href: "/extension",
      trackingName: "web_view_extension",
    },
    shrtlst: {
      name: "Shrtlst.",
      href: "https://shrtlst.com/",
      trackingName: "web_view_shrtlst",
    },
    forHotels: {
      name: I18n.t("views.navigation.for_hotels"),
      href: "https://hoteliers.theguestbook.com/",
      trackingName: "web_view_for_hotels",
    },
    contactUs: {
      name: I18n.t("views.navigation.contact_us"),
      href: "/contact_us",
      trackingName: "web_view_contact_us",
    },
    termsOfUse: {
      name: I18n.t("views.navigation.terms_of_use"),
      href: "/terms",
      trackingName: "web_view_terms_of_use",
    },
    privacyPolicy: {
      name: I18n.t("views.navigation.privacy_policy"),
      href: "/privacy",
      trackingName: "web_view_privacy_policy",
    },
    accessibility: {
      name: I18n.t("views.navigation.accessibility"),
      href: "/accessibility",
      trackingName: "web_view_accessibility",
    },
    mobileApp: {
      name: "Mobile App",
      href: "https://apps.apple.com/us/app/the-guestbook-hotel-rewards/id1416068849",
      trackingName: "web_view_mobile_app",
    },
    referAndEarn: {
      name: "Refer & Earn",
      href: "https://theguestbook.com/member_dashboard/referral_program?pid=theguestbook",
      trackingName: "web_view_refer_and_earn",
    },
    
    language: [
      { name: I18n.t("views.navigation.languages.english"), code: "en" },
      { name: I18n.t("views.navigation.languages.spanish"), code: "es" },
      { name: I18n.t("views.navigation.languages.french"), code: "fr" },
    ],
  },
};

export const guestbookSites = {
  development: {
    rewardsadmin: {
      url: "http://gstbk.com:3002",
    },
    guestbook: {
      url: "http://gstbk.com:3000",
    },
  },
  staging: {
    rewardsadmin: {
      url: "https://staging.rewardsadmin.com",
    },
    guestbook: {
      url: "https://theguestbookrewards.com",
    },
  },
  production: {
    rewardsadmin: {
      url: "https://rewardsadmin.com",
    },
    guestbook: {
      url: "https://theguestbook.com",
    },
  },
};

export const environment = process.env.NODE_ENV;
